import { jsx as _jsx } from "react/jsx-runtime";
import { useIsFetching } from '@tanstack/react-query';
import { CommonServiceApiTags } from 'common/services/api-tags';
import { useNotificationDrawerStore } from 'common/layouts/main-layout/service/notification-drawer-service/service-store/service-store';
import { useNotificationDrawerData } from 'common/layouts/main-layout/service/notification-drawer-service/query';
import { notificationDrawerServiceCurrentPageSelector, notificationDrawerServiceTotalPagesSelector, } from 'common/layouts/main-layout/service/notification-drawer-service/service-store/selectors';
import { Observer } from 'common/components/observer';
export var NotificationListController = function (_a) {
    var notificationContainerRef = _a.notificationContainerRef;
    var totalPages = useNotificationDrawerStore(notificationDrawerServiceTotalPagesSelector);
    var currentPage = useNotificationDrawerStore(notificationDrawerServiceCurrentPageSelector);
    var loading = !!useIsFetching({ queryKey: [CommonServiceApiTags.NotificationDrawer] });
    var nextPage = useNotificationDrawerData({
        scrollToTop: function () {
            var _a;
            (_a = notificationContainerRef === null || notificationContainerRef === void 0 ? void 0 : notificationContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0 });
        },
    });
    if (loading)
        return null;
    return (_jsx(Observer, { isObserved: currentPage + 1 < totalPages, cb: nextPage, style: { minHeight: '2rem', width: '100%' } }));
};
